import App from './App.svelte';
import { akitaDevtools, persistState } from '@datorama/akita';
import { isConnected } from './service';

akitaDevtools();
persistState();

const app = new App({
	target: document.body,
	props: {
		connected: false,
		local: false
	}
});

isConnected(connected, local);

export default app;